import { EnhancedModel } from '../__generated/configurator-builder.js';
import { implementCustomExpressions } from '../__generated/implementation.js';
import { getWoodMaterialProps } from '../data/texture-data.js';
export const apronExpressions = implementCustomExpressions({
    ApronBasic: {
        $apronFilter: (s)=>!EnhancedModel.$BaseFourLegCombined.is(s.$top.$table.$base),
        $fileUrl: (s)=>s.$top.$table.$glbFileUrl,
        $objectName: (s)=>s.$apronDataMap[s.$top.type]?.objectName,
        $offsetY: (s)=>s.$top.$offsetY - s.$top.thickness,
        $length: (s)=>{
            let length = s.$top.$length;
            if (s.$top.$leafCenterVisible && EnhancedModel.$TopWithSquareCorners.is(s.$top)) {
                length += s.$top.$leafLength * s.$top.leafAmount;
            }
            if (EnhancedModel.$RacetrackOvalTop.is(s.$top)) {
                // because the apron needs to remain a perfect circle and will be stretched
                length = s.$top.$width;
            }
            return length - (EnhancedModel.$BaseFourLeg.is(s.$top.$table.$base) ? s.$insetFromEdgeWithFourLegs : s.$insetFromEdge) * 2 + s.$beveledEdgeConsideration;
        },
        $width: (s)=>s.$top.$width - (EnhancedModel.$BaseFourLeg.is(s.$top.$table.$base) ? s.$insetFromEdgeWithFourLegs : s.$insetFromEdge) * 2 + s.$beveledEdgeConsideration,
        $thickness: (s)=>EnhancedModel.$BaseFourLeg.is(s.$top.$table.$base) ? s.$apronThicknessWithFourLegs : s.$apronThickness,
        $beveledEdgeConsideration: (s)=>EnhancedModel.$BaseFourLegSeparate.is(s.$top.$table.$base) ? s.$top.$table.$base.$beveledEdgeConsideration : 0,
        $stretch: (s)=>{
            const sizing = s.$apronDataMap[s.$top.type].sizing;
            let stretch = 'stretch' in sizing ? sizing.stretch.scaleZero : 0;
            if (EnhancedModel.$RacetrackOvalTop.is(s.$top)) {
                // The base circle diameter matches the width, so the stretch must account for
                // the extra length beyond the width. When length == width the apron is a perfect
                // circle (stretch stays at scaleZero, i.e. zero influence).
                stretch += s.$top.$length - s.$top.$width;
            }
            stretch += s.$top.$leafLength;
            return stretch;
        },
        $lengthScaleZero: (s)=>s.$apronDataMap[s.$top.type].sizing.length.scaleZero,
        $lengthScaleOne: (s)=>s.$apronDataMap[s.$top.type].sizing.length.scaleOne,
        $widthScaleZero: (s)=>s.$apronDataMap[s.$top.type].sizing.width.scaleZero,
        $widthScaleOne: (s)=>s.$apronDataMap[s.$top.type].sizing.width.scaleOne,
        $thicknessScaleZero: (s)=>s.$apronDataMap[s.$top.type].sizing.thickness.scaleZero,
        $thicknessScaleOne: (s)=>s.$apronDataMap[s.$top.type].sizing.thickness.scaleOne,
        $stretchScaleZero: (s)=>{
            const sizing = s.$apronDataMap[s.$top.type].sizing;
            return 'stretch' in sizing ? sizing.stretch.scaleZero : 0;
        },
        $stretchScaleOne: (s)=>{
            const sizing = s.$apronDataMap[s.$top.type].sizing;
            return 'stretch' in sizing ? sizing.stretch.scaleOne : 0;
        },
        // Material
        $finishColor: (s)=>EnhancedModel.$BaseFourLeg.is(s.$top.$table.$base) ? s.$top.$table.$base.$finishColor : s.$top.$finishColor,
        $textureUrl: (s)=>s.$top.$textureUrl,
        $normalMapUrl: (s)=>s.$top.$normalMapUrl,
        $roughnessMapUrl: (s)=>s.$top.$roughnessMapUrl,
        $aoMapUrl: (s)=>s.$top.$aoMapUrl,
        $repeatX: (s)=>(s.$length + s.$stretch) / s.$top.$table.$woodTextureSize,
        $repeatY: (s)=>s.$length / s.$top.$table.$woodTextureSize,
        // Material Properties
        $materialRoughness: (s)=>getWoodMaterialProps(s.$top.$table.woodSpecies, s.$top.$table.sheen).roughness,
        $materialMetalness: (s)=>getWoodMaterialProps(s.$top.$table.woodSpecies, s.$top.$table.sheen).metalness,
        $materialEnvMapIntensity: (s)=>getWoodMaterialProps(s.$top.$table.woodSpecies, s.$top.$table.sheen).envMapIntensity,
        $materialSpecularIntensity: (s)=>getWoodMaterialProps(s.$top.$table.woodSpecies, s.$top.$table.sheen).specularIntensity,
        $materialNormalScale: (s)=>getWoodMaterialProps(s.$top.$table.woodSpecies, s.$top.$table.sheen).normalScale,
        $materialReflectivity: (s)=>getWoodMaterialProps(s.$top.$table.woodSpecies, s.$top.$table.sheen).reflectivity
    }
});

//# sourceMappingURL=apron.js.map